import { useCallback } from 'react';
import { buscarStatusSolicitacaoApi } from '../api/BuscarStatusSolicitacaoApi';
import {
  SOLICITACAO_STATUS_DISPONIVEL,
  SOLICITACAO_STATUS_FALHOU,
  type StatusSolicitacaoApi,
} from '../types';

const INTERVALO_POLLING_MS = 3000;
const TIMEOUT_POLLING_MS = 120000;

function esperar(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function useAguardarSolicitacao() {
  const aguardarConclusao = useCallback(
    async (solicitacaoId: number): Promise<StatusSolicitacaoApi> => {
      const inicio = Date.now();

      while (Date.now() - inicio < TIMEOUT_POLLING_MS) {
        const solicitacao = await buscarStatusSolicitacaoApi(solicitacaoId);

        if (solicitacao.Status_id === SOLICITACAO_STATUS_DISPONIVEL) {
          return solicitacao;
        }

        if (solicitacao.Status_id === SOLICITACAO_STATUS_FALHOU) {
          throw new Error(solicitacao.Mensagem_Erro || 'Falha ao gerar o relatório.');
        }

        await esperar(INTERVALO_POLLING_MS);
      }

      throw new Error('Tempo limite excedido aguardando a geração do relatório.');
    },
    []
  );

  return { aguardarConclusao };
}
